import { showToast } from '../element';

/**
 * 获取状态消息
 * @param status 状态码
 */
export const getMessage = status => {
  let message = '';
  switch (status) {
    case 400:
      message = '请求错误(400)';
      break;
    case 401:
      message = '未授权，请重新登录(401)';
      break;
    case 403:
      message = '拒绝访问(403)';
      break;
    case 404:
      message = '请求出错(404)';
      break;
    case 408:
      message = '请求超时(408)';
      break;
    case 500:
      message = '服务器错误(500)';
      break;
    case 501:
      message = '服务未实现(501)';
      break;
    case 502:
      message = '网络错误(502)';
      break;
    case 503:
      message = '服务不可用(503)';
      break;
    case 504:
      message = '网络超时(504)';
      break;
    case 505:
      message = 'HTTP版本不受支持(505)';
      break;
    default:
      message = `连接出错(${status})!`;
  }
  return `${message}`;
};

/**
 * 显示状态消息
 * @param response axios 响应体
 */
export const showStatusMessage = response => {
  if (!response) return '未知错误';
  const message = getMessage(response.status);
  if (!response.config.hideError) {
    showToast({ type: 'error', message });
  }
  return message;
};
